import { isLocalStorageSupported } from "@outschool/local-storage";

const CLASS_PAGE_VISIT_HISTORY = "classPageVisitHistory";
const MAX_SIZE = 200;

const localStorage = isLocalStorageSupported();

export interface ClassPageVisit {
  activityUid: string;
  createdAt: Date;
}

export function pushToTop(activityUid: string) {
  if (!activityUid) {
    return;
  }
  const list = getListFromStore() || [];
  const newList = list
    .filter(item => !!item.activityUid)
    .filter(item => item.activityUid !== activityUid)
    .slice(0, MAX_SIZE);
  newList.unshift({ activityUid, createdAt: new Date() });
  saveListToStore(newList);
}

export function getList() {
  return getListFromStore() || [];
}

export function clear() {
  if (!localStorage) {
    return;
  }
  localStorage.removeItem(CLASS_PAGE_VISIT_HISTORY);
}

function getListFromStore() {
  if (!localStorage) {
    return [];
  }
  try {
    const jsonStr = localStorage.getItem(CLASS_PAGE_VISIT_HISTORY);
    const { list } = jsonStr ? JSON.parse(jsonStr) : { list: [] };
    return list as ClassPageVisit[];
  } catch (e) {
    console.log(e);
    return null;
  }
}

function saveListToStore(list: ClassPageVisit[]) {
  if (!localStorage) {
    return;
  }
  try {
    const jsonStr = JSON.stringify({ list });
    localStorage.setItem(CLASS_PAGE_VISIT_HISTORY, jsonStr);
  } catch (e) {
    console.log(e);
  }
}
